module.exports = __webpack_public_path__ + "static/img/ios4.0f81e18c.jpg";